<h2 mat-dialog-title class="dialog-title">{{ 'dialog.confirm_title' | transloco }}</h2>
<mat-dialog-content class="dialog-content">
  <p>{{ 'dialog.confirm_text' | transloco }}</p>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-button (click)="onCancel()" [disabled]="loading">{{ 'common.cancel' | transloco }}</button>
  <button mat-raised-button color="warn" (click)="onConfirm()" [disabled]="loading">
    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    <span *ngIf="!loading">{{ 'common.confirm' | transloco }}</span>
  </button>
</mat-dialog-actions>
